/**
 * Derives a human-friendly tab label from an additional asset's filename.
 *
 * Strips the extension, splits on common separators (`-`, `_`, spaces, `.`),
 * and title-cases each word. Falls back to the raw filename if nothing usable
 * remains.
 *
 * @example
 * additionalAssetLabel("cost.md")              // -> "Cost"
 * additionalAssetLabel("market-research.md")   // -> "Market Research"
 * additionalAssetLabel("risk_assessment.txt")  // -> "Risk Assessment"
 */
export function additionalAssetLabel(filename: string): string {
  // Drop the extension (last dot), unless the dot is leading (e.g. ".env").
  const lastDot = filename.lastIndexOf(".");
  const base = lastDot > 0 ? filename.slice(0, lastDot) : filename;

  const words = base
    .split(/[-_.\s]+/)
    .map((word) => word.trim())
    .filter((word) => word.length > 0);

  if (words.length === 0) {
    return filename;
  }

  return words
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ");
}
